export {
  asyncWithLDProvider,
  camelCaseKeys,
  useLDClientError,
  withLDProvider,
  withLDConsumer,
} from "launchdarkly-react-client-sdk-original";
import {
  LDProvider as OriginalLDProvider,
  useLDClient as useOriginalLDClient,
  ProviderConfig,
} from "launchdarkly-react-client-sdk-original";
import { LDClient } from "launchdarkly-js-client-sdk";
import { PropsWithChildren, ReactNode, type JSX } from "react";

const LD_INITIALIZATION_TIMEOUT_SECONDS = 5;

let resolver: () => void;

export const isLDClientReady = new Promise<void>((resolve) => {
  resolver = resolve;
});

let ldClient: LDClient;

export const useLDClient = () => ldClient;

const LDConsumer = ({ children }: { children: ReactNode }) => {
  const client = useOriginalLDClient();

  if (client && ldClient !== client) {
    ldClient = client;
    client.waitForInitialization(LD_INITIALIZATION_TIMEOUT_SECONDS).finally(resolver);
  }

  return children as JSX.Element;
};

export const LDProvider = ({ children, ...props }: PropsWithChildren<ProviderConfig>) => {
  return (
    <OriginalLDProvider {...props}>
      <LDConsumer>{children}</LDConsumer>
    </OriginalLDProvider>
  );
};

export { useFlags } from "./flags/useFlags";
